import * as React from 'react';
import styled from 'styled-components';
import DashboardLayout from '../layouts/DashboardLayout';
import ProjectsPage from './ProjectsPage';

const DashboardPageEmployee = () => {
  return (
    <DashboardLayout>
      <Container>
        <ProjectsPage />
      </Container>
    </DashboardLayout>
  );
};

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;
  background: var(--app-bg, var(--defaultBackground));

  @media (max-width: 840px) {
    padding: 0 12px;
  }

  @media (max-width: 540px) {
    padding: 0 10px;
  }
`;

export default DashboardPageEmployee;
